<template>
  <div class="stake-content">
    <div class="apy-rewards-content">
      <div class="apy-wrap">
        <p class="color bold apy-text">
          {{ $t("home.s2.stake.apytext") }}
        </p>
        <p class="color bold apy-number">
          {{ apy }}%
        </p>
      </div>
      <div class="rewards-wrap">
        <p class="bold rewards-title">
          {{ $t("home.s2.stake.rewardstitle") }}
        </p>
        <p class="default-text">
          {{ $t("home.s2.stake.rewardstext") }}
        </p>
      </div>
    </div>
    <div class="example-content">
      <div>
        <p class="default-text">
          {{ $t("home.s2.stake.ifstake") }}
        </p>
        <P class="number-text">
          2,000
        </P>
        <P class="default-text">
          LAMB
        </P>
      </div>
      <div class="bg-rewards">
        <p class="rewards-text">
          {{ $t("home.s2.stake.yourrewards") }}
        </p>
        <P class="rewards-number bold">
          {{ rewards }}
        </P>
      </div>
      <div>
        <p class="number-text">
          5%
        </p>
        <p class="default-text">
          {{ $t("home.s2.stake.COMMISSION") }}
        </p>
        <P class="default-text">
          {{ $t("home.s2.stake.validators") }}
        </P>
      </div>
    </div>
    <button class="staking-btn bold" @click="toStaking">
      {{ $t("home.s2.stake.stakingbtn") }}
    </button>
  </div>
</template>

<script>
import BigNumber from 'bignumber.js';
export default {
  data () {
    return {
      apy: 0,
      rewards:0,
    };
  },
  methods: {
    async getApy () {
      // let RawData = await fetch(`https://rest.lambda.im/cosmos/staking/v1beta1/pool`);
      // RawData = await RawData.json();
      // let { bonded_tokens } = RawData.pool;
      // bonded_tokens = new BigNumber(bonded_tokens);

      // let RawDataannual = await fetch(`https://rest.lambda.im/minting/annual-provisions`);
      // RawDataannual = await RawDataannual.json();

      // const alltokensBignumber = new BigNumber(RawDataannual.result);

      // let apy = alltokensBignumber.dividedBy(bonded_tokens);
      // apy = apy.toNumber() * 0.46 * 0.65;
      const apy = 0.8169813357673048;
      this.rewards = (2000*apy*(1-0.05)).toFixed(2);
      this.apy = (apy * 100 ).toFixed(2);
      
    },
    toStaking () {
      window.open('https://portal.lambda.im/staking');
    }
    
  },
  mounted () {
    this.getApy();
  }
};
</script>

<style lang="less" scoped>
.stake-content {
  p {
    margin-bottom: 0;
  }
  .color {
    color: #3f4ae1;
  }
  .bold {
    font-weight: bold;
  }
  .default-text {
    line-height: 24px;
    color: #333333;
  }
  .number-text {
    font-weight: 600;
    color: #474747;
  }

  .apy-rewards-content {
    .rewards-wrap {
      .rewards-title {
        color: #262626;
      }
    }
  }
  .example-content {
    .bg-rewards {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .rewards-text {
        color: #fff;
      }
      .rewards-number {
        color: #fff;
      }
    }
  }

  .staking-btn {
    width: 100%;
    outline: none;
    border: none;
    color: #ffffff;
    background: #3f4ae1;
    cursor: pointer;
  }
}
@media (max-width: 500px) {
  .default-text {
    font-size: 16px;
  }
  .number-text {
    font-size: 40px;
  }

  .apy-rewards-content {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .apy-wrap {
      margin-right: 0px;
      .apy-number {
        font-size: 50px;
      }
      .apy-text {
        font-size: 16px;
      }
    }
    .rewards-wrap {
      width: 100%;
      .rewards-title {
        font-size: 18px;
      }
    }
  }
  .example-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    .bg-rewards {
      width: 300px;
      height: 300px;
      background: url("../../../../assets/rewards.png") center center no-repeat;
      background-size: 70% 70%;
      .rewards-text {
        font-size: 14px;
      }
      .rewards-number {
        font-size: 32px;
      }
    }
  }

  .staking-btn {
    height: 60px;
    border-radius: 10px;
    font-size: 24px;
    margin-top: 40px;
  }
}
@media (min-width: 501px) {
  .default-text {
    font-size: 18px;
  }
  .number-text {
    font-size: 46px;
  }

  .apy-rewards-content {
    display: flex;
    align-items: center;
    justify-content: center;
    .apy-wrap {
      margin-right: 50px;
      .apy-number {
        font-size: 80px;
      }
      .apy-text {
        font-size: 18px;
      }
    }
    .rewards-wrap {
      width: 40%;
      height: 100%;
      .rewards-title {
        font-size: 24px;
      }
    }
  }
  .apy-rewards-content {
    display: flex;
    align-items: center;
    justify-content: center;
    .apy-wrap {
      margin-right: 60px;
      .apy-number {
        font-size: 70px;
      }
      .apy-text {
        font-size: 20px;
      }
    }
    .rewards-wrap {
      width: 40%;
      height: 100%;
      .rewards-title {
        font-size: 24px;
      }
    }
  }
  .example-content {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 50px;
    .bg-rewards {
      width: 50%;
      height: 340px;
      background: url("../../../../assets/rewards.png") center center no-repeat;
      background-size: 80% 80%;
      .rewards-text {
        font-size: 16px;
      }
      .rewards-number {
        font-size: 38px;
      }
    }
  }
  .staking-btn {
    height: 100px;
    border-radius: 16px;
    font-size: 26px;
    margin-top: 60px;
  }
}
@media (min-width: 1025px) {
  .default-text {
    font-size: 20px;
  }
  .number-text {
    font-size: 60px;
  }

  .apy-rewards-content {
    display: flex;
    align-items: center;
    justify-content: center;
    .apy-wrap {
      margin-right: 60px;
      .apy-number {
        font-size: 90px;
        line-height: 80px;
      }
      .apy-text {
        font-size: 20px;
      }
    }
    .rewards-wrap {
      width: 40%;
      height: 100%;
      .rewards-title {
        font-size: 24px;
      }
    }
  }
  .example-content {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 60px;
    .bg-rewards {
      width: 40%;
      height: 340px;
      background: url("../../../../assets/rewards.png") center center no-repeat;
      .rewards-text {
        font-size: 16px;
      }
      .rewards-number {
        font-size: 48px;
      }
    }
  }

  .staking-btn {
    height: 100px;
    border-radius: 16px;
    font-size: 30px;
    margin-top: 80px;
  }
}
</style>
